export default __webpack_public_path__ + "static/media/blue-checkmark.5e5309bb.svg";